import { Fixture, Vec2 } from "planck-js";
import { Component } from "../core/Component";
import { GameObject } from "../core/GameObject";
import { Ground } from "../game/Ground";
import { CharacterUnlockData } from "../game/MissionsState";
import { Player } from "../game/Player";
import { GameScene } from "../scenes/GameScene";


export class Whip extends Component {

	scene: GameScene;
	obj: Player;
	rope: Phaser.GameObjects.Image;
	originPoint: Phaser.Math.Vector2;
	collidePoint: Phaser.Math.Vector2;
	velocity: Phaser.Math.Vector2;
	hitGround = false;

	constructor(obj: Player, character: CharacterUnlockData) {
		super(obj);
		const rope = this.rope = obj.addImage("whip");
		rope.setOrigin(0, 0.5);
		rope.x = character.slamOrigin.x;
		rope.y = character.slamOrigin.y;
		
		this.originPoint = new Phaser.Math.Vector2(character.slamOrigin.x, character.slamOrigin.y);
		this.collidePoint = new Phaser.Math.Vector2(character.slamOrigin.x, character.slamOrigin.y);
		this.velocity = new Phaser.Math.Vector2(obj.planckBody.velocity.x, obj.planckBody.velocity.y * 2);
		this.velocity.normalize().scale(1500);
	}

	destroy() {
		this.rope.destroy();
		super.destroy();
	}

	public update(dt: number): void {
		this.collidePoint.x += this.velocity.x * dt;
		this.collidePoint.y += this.velocity.y * dt;
		const pt = this.obj.localTransform.transformPoint(this.collidePoint.x, this.collidePoint.y, new Phaser.Math.Vector2()) as Phaser.Math.Vector2;
		const dist = this.collidePoint.distance(this.originPoint);

		const body = this.obj.planckBody;
		const start = body.position.clone();
		const end = new Vec2(start.x + this.collidePoint.x * body.worldScale, start.y + this.collidePoint.y * body.worldScale);
		this.scene.world.rayCast(start, end, (fixture: Fixture, point: Vec2, normal: Vec2, fraction: number) => {
			const obj = fixture.getBody().getUserData() as GameObject;
			if (obj instanceof Ground) {
				const hitPoint = new Vec2(point.x * body.worldScale, point.y * body.worldScale);
				const dist2 = point.sub(body.position).length() * body.worldScale;
				if (dist > dist2) pt.set(hitPoint.x, hitPoint.y);
				return 0;
			}
			return 1;
		});

		const localPt = this.obj.localTransform.applyInverse(pt.x, pt.y, new Phaser.Math.Vector2()) as Phaser.Math.Vector2;
		const angle = Math.atan2(localPt.y - this.originPoint.y, localPt.x - this.originPoint.x);
		this.rope.rotation = angle;

		const dist2 = Phaser.Math.Distance.Between(this.rope.x, this.rope.y, localPt.x, localPt.y);
		console.log(`width: ${dist2}`);
		this.rope.displayWidth = dist2 - 20;
		this.rope.displayHeight = 10;
	}

}